/* eslint-disable max-len */
import CountdownToRedirect from './CountdownToRedirect'
import successGif from '../../Images/Success/end-screen.gif'
import { ASSET_SERVICE } from '../../Constants'

interface SuccessCopyProps {
  messageKey: string | null
}

interface Copy {
  line1?: string
  line2?: string
  lineWithHeart: string
  lineAtEnd: string
}

const getCopyByBriefType = (messageKey: string | null): Copy => {
  switch (messageKey) {
    case 'business':
      return {
        line1: "We'll now share your enquiry with suitable venues.",
        line2: undefined,
        lineAtEnd: 'You can then review your options, choose your favourite and request to book.',
        lineWithHeart: "You'll get personalised responses via email within 24 hours.",
      }
    case 'au-biz':
      return {
        line1: undefined,
        line2: undefined,
        lineWithHeart:
          'Thank you for submitting your event brief. One of the HeadBox team will be in touch within 4 working hours to discuss your enquiry.',
        lineAtEnd: 'You can then choose your favourite and request to book.',
      }
    case 'leadfeed':
      return {
        line1: "We'll now share your enquiry with suitable venues.",
        line2: undefined,
        lineAtEnd:
          "You can then review your options, match with your favourite venues and they'll be in touch.",
        lineWithHeart: 'Keep an eye on your email for up to 8 messages.️',
      }
    case 'enquiry':
      return {
        line1: 'The venue you enquired with should be in touch soon.',
        line2:
          "To help make sure you secure a great space, we've also shared your enquiry with other suitable venues.",
        lineAtEnd:
          "You can then review your options, match with your favourite venues and they'll be in touch.",
        lineWithHeart: 'Keep an eye on your email for up to 8 more Messages.️',
      }
    default:
      return {
        line1: "We'll now share your enquiry with suitable venues.",
        line2: undefined,
        lineAtEnd:
          "You can then review your options, match with your favourite venues and they'll be in touch.",
        lineWithHeart: 'Keep an eye on your email for up to 8 messages.️',
      }
  }
}

const SuccessCopy = ({ messageKey }: SuccessCopyProps): JSX.Element => {
  const messages = getCopyByBriefType(messageKey)
  const isBusinessUser = messageKey === 'business'
  return (
    <>
      {messages.line1 && <p>{messages.line1}</p>}
      {messages.line2 && <p>{messages.line2}</p>}
      <p className='line-with-heart'>💌&nbsp;{messages.lineWithHeart}&nbsp;💌</p>
      <img
        width='2500'
        height='1000'
        src={`${ASSET_SERVICE}${successGif}`}
        alt={'Image of paper plane taking off.'}
      />
      <p>{messages.lineAtEnd}</p>
      {isBusinessUser && <CountdownToRedirect />}
    </>
  )
}

export default SuccessCopy
